let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("10dT8")).then(() => parcelRequire('gKopa'));